import { KEYS, load, save } from './storage';

/** The in-app "Reduce motion" setting (on top of the OS preference). */
export function reduceMotionSetting(): boolean {
  return load<boolean>(KEYS.reduceMotion, false);
}

export function setReduceMotionSetting(on: boolean): void {
  save(KEYS.reduceMotion, on);
  applyReduceMotionClass();
}

/** Mirror the setting onto <html> so CSS can honor it like the media query. */
export function applyReduceMotionClass(): void {
  try {
    document.documentElement.classList.toggle('reduce-motion', reduceMotionSetting());
  } catch {
    /* no DOM */
  }
}

/** prefers-reduced-motion or the in-app setting, read live so a change applies at once. */
export function reducedMotion(): boolean {
  if (reduceMotionSetting()) return true;
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

/** Coarse pointer (touch) devices default to aim-then-commit swaps. */
export function coarsePointer(): boolean {
  try {
    return window.matchMedia('(pointer: coarse)').matches;
  } catch {
    return false;
  }
}

export function haptic(pattern: number | number[]): void {
  try {
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) navigator.vibrate(pattern);
  } catch {
    /* unsupported */
  }
}
